import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {DateAsNumberService} from './date-as-number.service';
import {FindEquipmentPriceService} from './find-equipment-price.service';
import {DocumentModel} from '../models/document.model';
import {FindProductPriceService} from './find-product-price.service';

@Injectable({
    providedIn: 'root'
})
export class HandleAccessoriesService {
    private discount = 0;

    constructor(private dateAsNumber: DateAsNumberService,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private findProductPriceService: FindProductPriceService) {
    }

    addAccessoriesToDoc(parentEquipment: DetaillineDTOModel, accessory: DetaillineDTOModel, document: DocumentModel) {
        console.log(parentEquipment);
        if (!parentEquipment.packageName && !parentEquipment.packageSeq) {
            parentEquipment.packageName = parentEquipment.pdesc;
            parentEquipment.packageSeq = this.dateAsNumber.dateAsNumber();
        }
        const tempAcc = JSON.parse(JSON.stringify(accessory));
        tempAcc.packageName = parentEquipment.pdesc;
        tempAcc.packageSeq = parentEquipment.packageSeq;
        tempAcc.total = 0;
        if (tempAcc.pdesc) {
            tempAcc.fromDate = parentEquipment.fromDate;
            tempAcc.toDate = parentEquipment.toDate;
            this.findEquipmentPriceService.getPrice(tempAcc, document.customer).then(equipmentList => {
                for (const equip of equipmentList) {
                    if (equip.pdesc === accessory.pdesc) {
                        tempAcc.weeklyRate = equip.week;
                        tempAcc.chargeLine = this.findEquipmentPriceService.addChargeLine(equip);
                        this.findEquipmentPriceService.isDiscountable(equip.tender).then(result => {
                            if (result === 1) {
                                this.discount = document.customer.hireDisc;
                            }

                        });
                    }
                }
            });
        } else if (tempAcc.plu) {
            this.findProductPriceService.getPrice(tempAcc, document.customer).then(res => {
                tempAcc.weeklyRate = res.price;
                this.findEquipmentPriceService.isDiscountable(res.tender).then(result => {
                    if (result === 1) {
                        this.discount = document.customer.saleDisc;
                    } else {
                        this.discount = 0;
                    }
                });
            });
        }
        tempAcc.discount = this.discount;
        tempAcc.location = document.location;
        tempAcc.total = tempAcc.weeklyRate - tempAcc.weeklyRate * tempAcc.discount / 100;
        return tempAcc;
    }

}
